export default __webpack_public_path__ + "static/media/MP_Profile_Contact_01.33eeef40.png";